/* Use the existing Shopify product form, including its selected variant and quantity. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-fm-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const form = document.getElementById(bar.dataset.form);
      const mainButton = form?.querySelector('button[name="add"]');
      const button = bar.querySelector('button');
      const priceSource = document.querySelector(`#Product-Info-${CSS.escape(bar.dataset.section)} [data-variant-info="price"]`);
      if (!form || !mainButton) return;
      const sync = () => {
        button.disabled = mainButton.disabled;
        button.textContent = mainButton.textContent.trim();
        const price = priceSource?.querySelector('.sale-price, .regular-price');
        if (price) bar.querySelector('[data-fm-price]').textContent = price.textContent.trim().replace(/\s+/g, ' ');
      };
      sync();
      const mutation = new MutationObserver(sync);
      mutation.observe(form, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']});
      if (priceSource) mutation.observe(priceSource, {childList: true, subtree: true});
      button.addEventListener('click', () => {
        if (!mainButton.disabled) form.requestSubmit(mainButton);
      });
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }, {threshold: 0});
      observer.observe(mainButton);
      const unload = event => {
        if (event.target.contains(bar)) {
          observer.disconnect(); mutation.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Small self-hosted movement clips. No automatic playback for reduced-motion or save-data users. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const allowed = () => !motion.matches && !navigator.connection?.saveData && !document.hidden;
  const instances = new Set();
  const pause = state => {
    state.policyPause = true;
    state.video.pause();
  };
  function init(root = document) {
    root.querySelectorAll('[data-fm-movement] video').forEach(video => {
      if (video.dataset.fmReady) return;
      video.dataset.fmReady = 'true';
      const state = {video, visible: false, manualPause: false, policyPause: false};
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          state.visible = entry.intersectionRatio >= .65;
          if (!state.visible) pause(state);
          else if (video.hasAttribute('data-fm-autoplay') && allowed() && !state.manualPause) {
            video.muted = true;
            video.play().catch(() => {});
          }
        }
      }, {threshold: [0, .65]});
      video.addEventListener('play', () => {
        state.policyPause = false;
        state.manualPause = false;
        if (mobile.matches) instances.forEach(other => { if (other !== state) pause(other); });
      });
      video.addEventListener('pause', () => {
        if (!state.policyPause && state.visible) state.manualPause = true;
      });
      state.observer = observer;
      instances.add(state);
      observer.observe(video);
    });
  }
  const pauseAll = () => instances.forEach(pause);
  document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); });
  motion.addEventListener('change', () => { if (motion.matches) pauseAll(); });
  navigator.connection?.addEventListener?.('change', () => { if (navigator.connection.saveData) pauseAll(); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach(state => {
      if (event.target.contains(state.video)) { pause(state);state.observer.disconnect();instances.delete(state); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();

(() => {
  const ns = 'http://www.w3.org/2000/svg';
  function icon(kind) {
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (kind === 'pause') svg.innerHTML = '<path d="M8 5v14M16 5v14" fill="none" stroke="currentColor" stroke-width="2"/>';
    else svg.innerHTML = '<path d="m9 5 11 7-11 7Z" fill="currentColor"/>';
    return svg;
  }
  function init(root = document) {
    root.querySelectorAll('.fm-media video, .fm-movement-video').forEach(video => {
      if (video.dataset.fmQuiet) return;
      video.dataset.fmQuiet = 'true';
      const host = video.parentElement;
      host.classList.add('fm-quiet-player');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fm-video-toggle';
      const sync = () => {
        const paused = video.paused || video.ended;
        button.setAttribute('aria-label', paused ? 'Video abspielen' : 'Video pausieren');
        button.replaceChildren(icon(paused ? 'play' : 'pause'));
      };
      sync();
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => { video.controls = true; button.hidden = true; });
        else video.pause();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      host.append(button);
      video.controls = false;
    });
    root.querySelectorAll('.fm-button span, .fm-text-link span, .fm-gallery__zoom span, .fm-material__zoom-label').forEach(span => {
      const label = span.textContent.trim();
      if (!label.endsWith('↗')) return;
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.classList.add('fm-arrow-icon');
      svg.innerHTML = '<path d="M5 19 19 5M5 5h14v14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      if (label === '↗') span.replaceWith(svg);
      else span.replaceChildren(document.createTextNode(label.slice(0, -1).trimEnd() + ' '), svg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
